const INITIAL_STATE = {
  franchiseList: [],
  data: {},
  commercialReports:{},
  commercialReportDetails: [],
  errors: {},
}
      
const getCommercialSales = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_REVENUE_REPORT_FRANCHISE_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, franchiseList: action.data }
  case 'GET_REVENUE_REPORT_FRANCHISE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_COMMERCIAL_SALES_REPORTS_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, commercialReports: action.data }
  case 'GET_COMMERCIAL_SALES_REPORTS_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_COMMERCIAL_SALES_REPORTS_BY_ID_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, commercialReportDetails: action.data }
  case 'GET_COMMERCIAL_SALES_REPORTS_BY_ID_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default getCommercialSales;